import { render, staticRenderFns } from "./createCourse.vue?vue&type=template&id=b5bd0220&scoped=true&"
import script from "./createCourse.vue?vue&type=script&lang=js&"
export * from "./createCourse.vue?vue&type=script&lang=js&"
import style0 from "./createCourse.vue?vue&type=style&index=0&id=b5bd0220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bd0220",
  null
  
)

export default component.exports